import React from 'react';
import { TextBox } from '../../shared/controls/form';
import SelectBox from '../../shared/controls/form/selectBox';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import info from '../../../src/assets/img/crm_home/main-content/info.png';

const BasicDetailsForm = ({
  formData,
  handleSubmit,
  selectedOptions,
  handleChange,
  handleChangeForm,
  handleDateTime,
  errormsg,
}) => {
    const owner = useSelector(getActiveOwners)
    const sqType = useSelector(getGenericMasterFilteredListByKey("SequenceType"))
//     const sqType = [
//     { id: 1, sqType: 'Lead Nurturing' },
//     { id: 2, sqType: 'Lead Nurturing' },
//     { id: 3, sqType: 'Lead Nurturing' },
//   ];
  const status = [
    { id: 1, label: 'Active' },
    { id: 2, label: 'Completed' },
    { id: 3, label: 'Draft' },
    { id: 4, label: 'Paused' },
  ];
  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      //   validationSchema={validationSchemaCampaign}
    >
      <Form>
        <div>
          <div className="formBlock">
            <div className="frmHdr">
              <h2>General Information</h2>
            </div>
            <div className="formContent">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="input-container">
                    <TextBox
                      isRequired={true}
                      label={'Sequence Name'}
                      name={'sequenceName'}
                      placeholder={'Enter Sequence Name'}
                      value={formData?.sequenceName}
                      handleChange={handleChangeForm}
                      maxLength={100}
                      errormsg={errormsg?.sequenceName}
                      disabled={formData?.type === 'view'}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="input-container">
                    <SelectBox
                      label={'Sequence Owner'}
                      name={'sequenceOwnerId'}
                      placeholder={formData?.sequenceOwner || 'Select Sequence Owner'}
                      selectedOptions={selectedOptions?.owner}
                      handleSelect={handleChange}
                      options={owner}
                      optionKeys={['userId', 'display_name']}
                      errormsg={errormsg?.owner}
                      disabled={formData?.type === 'view'}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="input-container">
                    <SelectBox
                      label={'Sequence Type'}
                      name={'sequenceTypeId'}
                      placeholder={formData?.sequenceType || 'Select Sequence Type'}
                      selectedOptions={selectedOptions}
                      handleSelect={handleChange}
                      options={sqType}
                      optionKeys={['id', 'displayName']}
                      errormsg={errormsg?.sqType}
                      disabled={formData?.type === 'view'}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="input-container">
                    <SelectBox
                      label={'Status'}
                      name={'statusId'}
                      placeholder={formData?.status || 'Select Status'}
                      selectedOptions={selectedOptions?.status}
                      handleSelect={handleChange}
                      options={status}
                      optionKeys={['id', 'label']}
                      errormsg={errormsg?.status}
                      disabled={formData?.type === 'view'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="formBlock">
            <div className="frmHdr">
              <h2>Schedule</h2>
            </div>
            <div className="formContent">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="input-container">
                    <label>
                      Start Date<span className="required-star">*</span>
                    </label>
                    <div className="dtBox">
                      <DateTimePicker
                        label={'Schedule Date Time'}
                        isRequired={true}
                        value={
                          formData?.scheduledDateTime ? new Date(formData?.scheduledDateTime) : null
                        }
                        onChange={handleDateTime}
                        name="scheduledDateTime"
                        placeholder="Select Schedule date & time"
                        disabled={formData?.type === 'view'}
                        errormsg={errormsg?.scheduledDateTime}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="formBlock">
            <div className="frmHdr">
              <h2>Target Module</h2>
            </div>
            <div className="formContent">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="input-container">
                    <label>Module</label>
                    <div className="rdBtnGroup">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="leads"
                          id="contactRadioBtn"
                          defaultChecked
                        />
                        <label className="form-check-label mb-0" for="contactRadioBtn">
                          Leads
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="contact"
                          id="contactRadioBtn"
                          disabled
                        />
                        <label className="form-check-label mb-0" for="contactRadioBtn">
                          Contacts
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                  <div className="input-container">
                    <label>Mode</label>
                    <div className="rdBtnGroup">
                      <div className="form-check ">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="randomRecords"
                          id="randomRecords"
                          defaultChecked
                        />
                        <label className="form-check-label mb-0" for="randomRecords">
                          Random Records
                        </label>
                      </div>
                      <div className="form-check ">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="manualSelection"
                          id="Manual Selection"
                          disabled
                        />
                        <label className="form-check-label mb-0" for="Manual Selection">
                          Manual Selection (Comin Soon...)
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                      <div className="input-container">
                        <TextBox
                          isRequired={true}
                          label={'Max Recipients per Batch'}
                          name={'maxRecipientsPerBatch'}
                          placeholder={'Enter Max Recipients'}
                          value={formData?.maxRecipientsPerBatch}
                          handleChange={handleChangeForm}
                          maxLength={100}
                          errormsg={errormsg?.maxRecipientsPerBatch}
                          disabled={formData?.type === 'view'}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                      <div className="infoMsg">
                        <img src={info} alt="" />
                        <p>
                          Maximum number of emails to send per day to prevent overwhelming
                          recipients
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default BasicDetailsForm;
